import styled from 'styled-components';

const DialogActions = styled.div`
    flex: 0 0 auto;
    padding: 8px 4px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

export default DialogActions;
